module.exports = __webpack_public_path__ + "img/antebraco-e.7f6776f3.png";